import React, { Component } from "react";
import Moment from "moment";
import { extendMoment } from "moment-range";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import Units from "./Units";

const moment = extendMoment(Moment);

class Picker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			start: moment().format("YYYY-MM-DD"), // by default showing price per day.
			end: moment().add(1, "days").format("YYYY-MM-DD")
		};
	}

	handleOnChange(e) {
		const state = this.state;
		state["start"] = moment(e[0]).format("YYYY-MM-DD");
		state["end"] = moment(e[1]).format("YYYY-MM-DD");
		this.setState(state);
	}
	// console.log(e);

	static getDerivedStateFromProps(props, state) {
		props.options.disable = props.disabled;
		if (state.start !== "" && state.end !== "") {
			props.options[0].minDate = state.start;
		}
		//console.log("derived ran");
		return null;
	}

	shouldComponentUpdate(props, state) {
		// console.log(state.start);
		// console.log(state.end);
		if (state.start <= state.end && state.start !== "" && state.end !== "") {
			props.options[0].minDate = moment().format("YYYY-MM-DD");
		}
		if (state.reload) {
			state = {
				start: "",
				end: ""
			};
		}

		//console.log("should ran");
		return state;
	}

	render() {
		const options = Object.assign({}, this.props.options[0]);
		const { start, end } = this.state;

		return (
			<>
				<Units
					item={this.props.item}
					start={start}
					ref={this.props.ref}
					end={end}
					dates={this.props.dates}
					disabled={options.disable}
				/>
				<div
					className="col-lg-12"
					style={{
						display: "inline",
						float: "left",
						marginTop: "5px",
						marginBottom: "5px"
					}}
				>
					<Flatpickr
						id="date_from"
						key="date_from"
						data-id="rangePlugin"
						placeholder="From - To"
						options={{
							altInput: options.altInput,
							mode: "range",
							disable: options.disable,
							minDate: options.minDate,
							maxDate: options.maxDate,
							altFormat: options.altFormat,
							dateFormat: options.dateFormat,
							onChange: (e) => {
								this.handleOnChange(e);
							}
						}}
					/>
					<input type="hidden" name="from" value={start} />
					<input type="hidden" name="to" value={end} />
				</div>
			</>
		);
	}
}

export default Picker;
